import useElysiaStore from '@/app/elysia-store';

const ChatSystemFooterMessage = () => {
  const appCreator = useElysiaStore((state) => state.appCreator);
  const appType = useElysiaStore((state) => state.appType);
  const chatAgent = useElysiaStore((state) => state.chatAgent);
  const serviceNowLink = useElysiaStore((state) => state.serviceNowLink);

  return (
    <div className="text-center">
      {chatAgent === 'app-agent' && (
        <>
          <span
            className="me-3 feedback-line text-align text-center"
            data-testid="created-by-label"
          >
            {appType === 'global' ? (
              <>
                Any issue found please raise a &nbsp;
                <a target="_blank" className="color-primary" href={serviceNowLink} rel="noreferrer">
                  ServiceNow ticket.
                </a>
              </>
            ) : (
              <>Created by {appCreator}. For any queries, please contact them.</>
            )}
          </span>
        </>
      )}
    </div>
  );
};
export default ChatSystemFooterMessage;
